import {
  type AdminLoginResponse,
  AdminLoginResponseSchema,
} from "contracts/api/admin/responses";
import type { DemoIdentity } from "contracts/demos/registry";
import { createSignal } from "solid-js";

const KEY = "faro:session";
const [session, setSession] = createSignal<AdminLoginResponse | null>(null);
export const isAdmin = () => session() !== null;
const sessionToken = () => session()?.token ?? null;

export function sameDemo(left: DemoIdentity, right: DemoIdentity): boolean {
  return (
    left.demoId === right.demoId && left.incarnationId === right.incarnationId
  );
}

export function restoreSession(identity: DemoIdentity): boolean {
  try {
    const parsed = AdminLoginResponseSchema.safeParse(
      JSON.parse(localStorage.getItem(KEY) ?? "null"),
    );
    if (parsed.success && sameDemo(parsed.data, identity)) {
      setSession(parsed.data);
      return true;
    }
  } catch {
    /* Invalid stored sessions cannot authorize a request. */
  }
  clearSession();
  return false;
}

export function acceptSession(
  value: AdminLoginResponse,
  identity: DemoIdentity,
): void {
  if (!sameDemo(value, identity))
    throw new Error("Session belongs to a different environment");
  localStorage.setItem(KEY, JSON.stringify(value));
  setSession(value);
}

export function clearSession(): void {
  localStorage.removeItem(KEY);
  setSession(null);
}

export function authorizationHeaders(): Record<string, string> {
  const token = sessionToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export function adminGateProps(
  disabled: boolean,
  verb: string,
): { disabled: boolean; title: string | undefined } {
  return {
    disabled: disabled || !isAdmin(),
    title: isAdmin() ? undefined : `Sign in to ${verb}`,
  };
}
